import React, { useEffect, useState } from "react"
import { toast } from "react-toastify"
import { Button, Modal, Form } from "react-bootstrap"
import Select from "react-select"
import PaginationTable from "../../components/paginationTable"
import SearchBar from "../../components/searchBar"
import {
    fetchUsers,
    fetchUsersCount,
    createNewUser,
    fetchUserDetails,
    updateUsersInfo,
    deleteUser,
} from "../../actions/commonController"
import { useAuth } from "../../context/authContext"
import { utcDate, formatDate } from "../../config/utcDate"
import { isEmpty } from "../../config/funcs"

const UserList = () => {
    const [data, setData] = useState([])
    const [showCreateModal, setShowCreateModal] = useState(false)
    const [showEditModal, setShowEditModal] = useState(false)
    const [showDeleteModal, setShowDeleteModal] = useState(false)
    const [userToDelete, setUserToDelete] = useState(null)
    const [formValue, setFormValue] = useState({
        username: "",
        role: "",
    })
    const [totalItems, setTotalItems] = useState(0)
    const [itemsPerPage, setItemsPerPage] = useState(10)
    const [page, setPage] = useState(1)
    const [quantity, setQuantity] = useState(10)
    const [searchTerm, setSearchTerm] = useState("")
    const [modalLoader, setModalLoader] = useState(false)
    const [editModalLoader, setEditModalLoader] = useState(false)
    const [deleteLoader, setDeleteLoader] = useState(false)
    const [loader, setLoader] = useState(false)
    const [initLoad, setInitLoad] = useState(false);
    const { eid } = useAuth

    const rolesOptions = ['Admin', 'Manager', 'User']

    const handleChange = (e) => {
        let { name, value } = e.target
        setFormValue(prev => ({
            ...prev,
            [name]: value,
        }))
    }

    const handleRoleChange = (role) => {
        setFormValue(prev => ({
            ...prev,
            role: role
        }))
    }

    const openCreateModal = () => {
        setFormValue(formValue)
        setShowCreateModal(true)
    }

    const closeCreateModal = () => {
        setFormValue(formValue)
        setShowCreateModal(false)
    }

    const handlePageChange = (page) => {
        setPage(page)
    }

    const handleItemsPerPageChange = (newItemsPerPage) => {
        setQuantity(newItemsPerPage)
        setPage(1)
    }

    const handleEdit = async (userId) => {
        setFormValue(formValue)
        setShowEditModal(true)
        try {
            let APIData = {
                userid: userId
            }
            const { data } = await fetchUserDetails(APIData)
            if (data) {
                const userData = data[0]
                setFormValue({
                    userId: userId,
                    username: userData.username,
                    role: userData.role
                })
            } else {
                toast.error("Failed to fetch user details")
            }
        } catch (error) {
            toast.error("An error occurred while fetching user details")
        }
    }

    const closeEditModal = () => setShowEditModal(false)

    const handleCreateUser = async () => {
        try {
            const APIData = {
                username: formValue.username,
                role: formValue.role,
            }

            console.log("APIData", APIData)
            setModalLoader(true)

            const { status, error } = await createNewUser(APIData)
            if (status === "success") {
                toast.success("User created successfully!")
                closeCreateModal()
                loadData()
            } else {
                toast.error(error)
            }
        } catch (err) {
            toast.error("An error occurred while creating the user")
        } finally {
            setModalLoader(false)
        }
    }

    const handleUpdateUser = async () => {
        try {
            const updatedAPIData = {
                userId: formValue.userId,
                username: formValue.username,
                role: formValue.role
            }

            setEditModalLoader(true)

            const { status, error } = await updateUsersInfo(updatedAPIData)
            if (status === "success") {
                toast.success("User updated successfully")
                closeEditModal()
                loadData()
            } else {
                toast.error(error)
            }
        } catch (error) {
            toast.error("An error occurred while updating the user")
        } finally {
            setEditModalLoader(false)
        }
    }

    const handleDelete = (userId) => {
        setUserToDelete(userId)
        setShowDeleteModal(true)
    }

    const handleConfirmDelete = async () => {
        if (userToDelete) {
            setDeleteLoader(true)
            try {
                const deleteData = {
                    userId: userToDelete
                }
                const { status, error } = await deleteUser(deleteData)
                if (status === "success") {
                    toast.success("User deleted successfully")
                    setShowDeleteModal(false)
                    loadData()
                } else {
                    toast.error(error || "Failed to delete user")
                }
            } catch (err) {
                toast.error("An error occurred while deleting the user")
            } finally {
                setDeleteLoader(false)
            }
        }
    }

    const initialization = async () => {
        try {
            let APIData = {
                // search: searchTerm,
                userStatus: formValue.role,
            }

            setLoader(true)
            let { status, data } = await fetchUsersCount(APIData)

            if (status === "success") {
                setTotalItems(data)
                await loadData()
                setInitLoad(true)
            }
        } catch (err) {
            console.error("Error in loadData function", err)
        }
    }

    const loadData = async () => {
        try {
            let APIData = {
                page: page,
                quantity: quantity,
            }

            setLoader(true)
            const { data } = await fetchUsers(APIData)
            setData(data)
            setPage(page)
        } catch (error) {
            console.error("Error fetching users:", error)
        } setLoader(false)
    }

    useEffect(() => {
        if (initLoad) loadData()
    }, [page, quantity])

    useEffect(() => {
        initialization()
    }, [])

    return (
        <div className="container-fluid">

            <div className="row">
                <div className="col-12">
                    <div className="page-title-box">
                        <div className="page-title-right">
                            <Button variant="primary"
                                // onClick={openCreateModal}
                                onClick={"You are not allowed to create a user" === "You are not allowed to create a user" ? () => toast.error("You are not allowed to create a user") : openCreateModal()}
                            >
                                <i className="ri-add-line"></i> Add User
                            </Button>
                        </div>
                        <h4 className="page-title">User Management</h4>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <div className="card">
                        {/* <div className="card-header d-flex justify-content-between align-items-center">

                            <div className="d-flex align-items-center">
                                <SearchBar onSearch={setSearchTerm} searchText="Search by name..." />
                            </div>
                        </div> */}
                        <div className="card-body">
                            {loader ? (
                                <div className="text-center">
                                    <div className="spinner-border" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                            ) : (
                                <div className="table-responsive">
                                    <table className="table table-centered table-hover table-nowrap mb-0">
                                        <thead className="table-light">
                                            <tr>
                                                <th>S. No</th>
                                                <th>Username</th>
                                                <th>Role</th>
                                                <th>Login At</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {data.map((users) => (
                                                <tr key={users.id}>
                                                    <td>{users.id}</td>
                                                    <td>{users.username}</td>
                                                    <td>{users.role}</td>
                                                    <td>  {!isEmpty(users.lastLogin) ? utcDate(users.lastLogin) : "-"}</td>
                                                    <td>
                                                        <button
                                                            className="btn btn-sm btn-outline-primary me-1"
                                                            // onClick={() => handleEdit(users.id)}
                                                            onClick={"You are not allowed to edit a user" === "You are not allowed to edit a user" ? () => toast.error("You are not allowed to edit a user") : handleEdit(users.id)}
                                                        >
                                                            <i className="ri-edit-line"></i>
                                                        </button>
                                                        <button
                                                            className="btn btn-sm btn-outline-danger"
                                                            // onClick={() => handleDelete(users.id)}
                                                            onClick={"You are not allowed to delete a user" === "You are not allowed to delete a user" ? () => toast.error("You are not allowed to delete a user") : handleDelete(users.id)}
                                                        >
                                                            <i className="ri-delete-bin-line"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    {data.length === 0 && (
                                        <div className="text-center py-4">
                                            <p>No users found. Add your first user!</p>
                                        </div>
                                    )}
                                </div>
                            )}

                        </div>
                    </div>
                    {/* Pagination Component */}
                    <PaginationTable
                        totalItems={totalItems}
                        itemsPerPage={itemsPerPage}
                        pageChange={handlePageChange}
                        onItemsPerPageChange={handleItemsPerPageChange}
                    />
                </div>

                {/* Create User Modal */}
                <Modal size="sx" show={showCreateModal} onHide={closeCreateModal} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Create New User</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <Form.Group className="mb-3">
                                <Form.Label>Username</Form.Label>
                                <Form.Control type="text" name="username" value={formValue.username} onChange={handleChange} placeholder="Enter username" />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label className="form-label">Role</Form.Label>
                                <Select name="role" options={rolesOptions} value={rolesOptions.find(r => r.value === formValue.role)} onChange={handleRoleChange} />
                            </Form.Group>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={closeCreateModal}>Close</Button>
                        {
                            modalLoader ?
                                <button className="btn btn-primary" disabled>
                                    <span className="spinner-border spinner-border-sm me-1" role="status"
                                        aria-hidden="true"></span>
                                    Creating...
                                </button>
                                :
                                <Button variant="primary" onClick={handleCreateUser} disabled={modalLoader}>
                                    Create User
                                </Button>
                        }
                        {/* <Button variant="primary" onClick={handleCreateUser} disabled={modalLoader}>
                        {modalLoader ? "Creating..." : "Create User"}
                    </Button> */}
                    </Modal.Footer>
                </Modal>

                {/* Edit User Modal */}
                <Modal size="sx" show={showEditModal} onHide={closeEditModal} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Edit User</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <Form.Group className="mb-3">
                                <Form.Label>Username</Form.Label>
                                <Form.Control type="text" name="username" value={formValue.username} onChange={handleChange} placeholder="Enter user name" />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>Role</Form.Label>
                                <Select name="role" options={rolesOptions} value={rolesOptions.find(r => r.value === String(formValue.role))} onChange={handleRoleChange} />
                            </Form.Group>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={closeEditModal}>Close</Button>
                        {
                            editModalLoader ?
                                <button className="btn btn-primary" disabled>
                                    <span className="spinner-border spinner-border-sm me-1" role="status"
                                        aria-hidden="true"></span>
                                    Saving...
                                </button>
                                :
                                <Button variant="primary" onClick={handleUpdateUser} disabled={editModalLoader}>
                                    Save changes
                                </Button>
                        }
                    </Modal.Footer>
                </Modal>

                {/* Delete Confirmation Modal */}
                <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
                    <Modal.Header closeButton>
                        <Modal.Title>Confirm Delete</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>Are you sure you want to delete this user?</p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>No</Button>
                        {/* <Button variant="danger" onClick={handleConfirmDelete}>Yes, Delete</Button> */}
                        {
                            deleteLoader ?
                                <button className="btn btn-danger" disabled>
                                    <span class="spinner-border spinner-border-sm me-1" role="status"
                                        aria-hidden="true"></span>
                                    Deleting...
                                </button>
                                :
                                <Button variant="danger" onClick={handleConfirmDelete} disabled={deleteLoader}>
                                    Yes, delete
                                </Button>
                        }
                    </Modal.Footer>
                </Modal>
            </div>
        </div>
    )
}

export default UserList
